module.exports = new __parcel__URL__("PROFILE.954ebb94.jpg").toString();